import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { endpoints, getIDFromUrl, loadEtag, Url } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';

export const RAW_SCHEMA_QUERY_KEY = 'raw-schema';

export const useRawSchema = (schemaUrl: Url | undefined) => {
  return useQuery({
    queryKey: [RAW_SCHEMA_QUERY_KEY, schemaUrl] as const,
    queryFn: () =>
      api
        .fullRequest(endpoints.schemas.getRaw(getIDFromUrl(schemaUrl!)))
        .then(loadEtag),
    enabled: schemaUrl !== undefined,
  });
};

export const useAcknowledgeChanges = (schemaUrl: Url | undefined) => {
  const queryClient = useQueryClient();
  const acknowledgeChanges = useCallback(
    (data: unknown) => {
      queryClient.setQueryData([RAW_SCHEMA_QUERY_KEY, schemaUrl], data);
    },
    [queryClient, schemaUrl]
  );
  return { acknowledgeChanges };
};
